import { render, staticRenderFns } from "./ListRoles.vue?vue&type=template&id=2496193e&scoped=true&"
import script from "./ListRoles.vue?vue&type=script&lang=js&"
export * from "./ListRoles.vue?vue&type=script&lang=js&"
import style0 from "./ListRoles.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ListRoles.vue?vue&type=style&index=1&id=2496193e&scoped=true&lang=css&"
import style2 from "./ListRoles.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2496193e",
  null
  
)

export default component.exports